import { FormControlLabel, Radio, RadioGroup, styled } from '@mui/material';

export const Label = styled(FormControlLabel)(
  () => `
  .MuiFormControlLabel-label {
    font-weight: 300;
  }
`,
);

export const RadioField = styled(Radio)`
  padding: 5px 7px 5px 9px;
`;

export const RadioGroupField = styled(RadioGroup)``;
